import React from 'react';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Link from '@mui/material/Link';
import PropTypes from 'prop-types';
import { palette } from '../../../theme';
import { GetADomainBtn, OpenDesignAppTourBtn } from './GetADomainBtn';
import Links from '../../../constants/links';
import { SubTitle } from '../../common';

export const DomainSetUpInstructions = ({ domainPurchaseResponse }) =>
  domainPurchaseResponse?.result === 'success' ? (
    <Card sx={{ backgroundColor: palette.cardBg }}>
      <Stack direction="column" spacing={2} alignItems="center">
        <SubTitle>
          {domainPurchaseResponse.domain
            ? `Congratulations! ${domainPurchaseResponse.domain} is now yours.`
            : 'Congratulations on your new domain!'}
        </SubTitle>
        <Typography>Next, connect your new domain to your design.</Typography>
        <OpenDesignAppTourBtn title="Connect Domain" primary />
      </Stack>
    </Card>
  ) : (
    <Card
      sx={{
        backgroundColor: palette.cardBg,
      }}
    >
      <Stack direction="column" spacing={2} alignItems="center">
        <Typography mb={2}>
          You can get a domain <strong>free for 1 year</strong> or connect one you already own.{' '}
          <Link href={Links.IONOS_DOMAIN_PURCHASE_URL} target="_blank" rel="noopener noreferrer">
            Learn More
          </Link>
        </Typography>

        <Stack direction="row" spacing={2} width="100%" alignItems="center" justifyContent="center">
          <GetADomainBtn />
          <OpenDesignAppTourBtn />
        </Stack>
      </Stack>
    </Card>
  );

DomainSetUpInstructions.propTypes = {
  domainPurchaseResponse: PropTypes.shape({
    domain: PropTypes.string,
    result: PropTypes.string,
  }).isRequired,
};
